import { observable } from "@legendapp/state";
import type { ReadingSessionState } from "./reading-session";
import type { UiState } from "./ui-state";
import type { ExerciseState } from "./exercise";
import type { VocabularyExerciseState } from "@/ear-reader/types/vocabulary-exercise";
import {
  createInitialReadingSessionState,
  createInitialUiState,
  createInitialExerciseState,
  createInitialVocabularyExerciseState,
  createInitialFluencyState,
  applyPageUIReset,
  applyPageExerciseReset,
  type FluencyState,
} from "./initial-state";

export const readingSessionStore$ = observable<ReadingSessionState>(
  createInitialReadingSessionState(),
);

export const uiStateStore$ = observable<UiState>(createInitialUiState());

export const exerciseStore$ = observable<ExerciseState>(
  createInitialExerciseState(),
);

export const vocabularyExerciseStore$ = observable<VocabularyExerciseState>(
  createInitialVocabularyExerciseState(),
);

export const fluencyStore$ = observable<FluencyState>(
  createInitialFluencyState(),
);

export function resetReadingUI(): void {
  readingSessionStore$.currentPage.set(0);

  const inputType = uiStateStore$.inputType.peek();
  const tutorialDismissed = uiStateStore$.tutorialDismissed.peek();

  uiStateStore$.set({
    ...createInitialUiState(),
    inputType,
    tutorialDismissed,
  });

  exerciseStore$.set(createInitialExerciseState());
  vocabularyExerciseStore$.set(createInitialVocabularyExerciseState());
}

export function resetPageUI(): void {
  uiStateStore$.set(applyPageUIReset(uiStateStore$.peek()));
  exerciseStore$.set(applyPageExerciseReset(exerciseStore$.peek()));
}
